import { HttpService } from "@/core";
import { UserSimpleListReq, UserSimpleListResp } from "./sales-man.interface";

export class SalesManService {
  static useSimpleListApi() {
    const api = (params: UserSimpleListReq) =>
      HttpService.axios({
        method: "GET",
        url: "/tenant_user/simple/list",
        params,
      });
    return HttpService.useRequest<UserSimpleListResp>(api);
  }
}
